// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3XY50","detailsBorder":"styles_detailsBorder__3kkGr"};